import { supabase } from '../lib/supabase';

export const core4Service = {
  // Get CORE4 entries for a specific date
  async getCore4Entries(userId, date = null) {
    try {
      const targetDate = date || new Date()?.toISOString()?.split('T')?.[0]
      
      const { data, error } = await supabase?.from('core4_entries')?.select('*')?.eq('user_id', userId)?.eq('entry_date', targetDate)?.order('area')

      if (error) {
        return { entries: [], error }
      }

      return { entries: data || [], error: null }
    } catch (error) {
      return { 
        entries: [], 
        error: { message: 'Failed to load CORE4 entries.' }
      }
    }
  },

  // Upsert CORE4 entry (update if exists, create if not)
  async upsertCore4Entry(userId, entryData) {
    try {
      const targetDate = entryData?.date || new Date()?.toISOString()?.split('T')?.[0]
      
      const { data, error } = await supabase?.from('core4_entries')?.upsert([{
          user_id: userId,
          entry_date: targetDate,
          area: entryData?.area,
          goal_description: entryData?.goalDescription,
          status: entryData?.status || 'pending',
          completed_at: entryData?.status === 'completed' ? new Date()?.toISOString() : null,
          notes: entryData?.notes
        }], {
          onConflict: 'user_id,entry_date,area'
        })?.select()?.single()

      return { entry: data, error }
    } catch (error) {
      return { 
        entry: null, 
        error: { message: 'Failed to update CORE4 entry.' }
      }
    }
  },

  // Toggle CORE4 completion status
  async toggleCore4Completion(userId, area, date = null, completed = true) {
    try {
      const targetDate = date || new Date()?.toISOString()?.split('T')?.[0]
      
      const { data, error } = await supabase?.from('core4_entries')?.update({
          status: completed ? 'completed' : 'pending',
          completed_at: completed ? new Date()?.toISOString() : null
        })?.eq('user_id', userId)?.eq('entry_date', targetDate)?.eq('area', area)?.select()?.single()

      return { entry: data, error }
    } catch (error) {
      return { 
        entry: null, 
        error: { message: 'Failed to update CORE4 status.' }
      }
    }
  },

  // Get CORE4 completion stats for analytics
  async getCore4Stats(userId, startDate = null, endDate = null) {
    try {
      let query = supabase?.from('core4_entries')?.select('area, status, entry_date')?.eq('user_id', userId)

      if (startDate) {
        query = query?.gte('entry_date', startDate)
      }
      if (endDate) {
        query = query?.lte('entry_date', endDate)
      }

      const { data, error } = await query?.order('entry_date', { ascending: false })

      if (error) {
        return { stats: null, error }
      }

      // Calculate stats by area
      const stats = {
        faith: { completed: 0, total: 0 },
        family: { completed: 0, total: 0 },
        finances: { completed: 0, total: 0 },
        fitness: { completed: 0, total: 0 }
      }

      data?.forEach(entry => {
        const area = entry?.area
        if (stats?.[area]) {
          stats[area].total++
          if (entry?.status === 'completed') {
            stats[area].completed++
          }
        }
      })

      return { stats, error: null }
    } catch (error) {
      return { 
        stats: null, 
        error: { message: 'Failed to calculate CORE4 stats.' }
      }
    }
  }
}